namespace InvData {

    export enum SpecialEntityTypeIds {

        Accounting = 1,

        CashAccount = 2,
        Liabilities = 3,
        Receivables = 4,

        TotalReturnIndex = 5,
        ConstantWeightTotalReturnIndex = 13,
        WeightedBenchmark = 14,

        DrawdownFund = 12,
        ExternalDrawdownFund = 6,

        ManagedFund = 7,
        UnitizedManagedFund = 18,
        ExternalManagedFund = 11,

        AggregateView = 8,
        AggregateCashView = 10,

        Derivative = 9,

        Composite = 15,
        Outsider = 16,
        PublicEquity = 17,

        FXMirror = 19
    }

}

namespace InvData.SpecialEntityTypeIds {

    export function isDrawdownFund(seTypeId: number): boolean {
        if (seTypeId == InvData.SpecialEntityTypeIds.DrawdownFund || seTypeId == InvData.SpecialEntityTypeIds.ExternalDrawdownFund) {
            return true;
        }

        return false;
    }

    export function isAggregateView(seTypeId: number): boolean {
        if (seTypeId == InvData.SpecialEntityTypeIds.AggregateView || seTypeId == InvData.SpecialEntityTypeIds.AggregateCashView) {
            return true;
        }

        return false;
    }

}

